import { CALL_API, Schemas } from '../../common/middleware/api';

export const INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_REQUEST = 'INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_REQUEST';
export const INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_SUCCESS = 'INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_SUCCESS';
export const INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_FAILURE = 'INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_FAILURE';

export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEMS_UPDATE_REQUEST = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEMS_UPDATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEMS_UPDATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEMS_UPDATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEMS_UPDATE_FAILURE = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEMS_UPDATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_CREATE_REQUEST = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_CREATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_CREATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_CREATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_CREATE_FAILURE = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_CREATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_FETCH_REQUEST = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_FETCH_REQUEST';
export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_FETCH_SUCCESS = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_FETCH_SUCCESS';
export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_FETCH_FAILURE = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_FETCH_FAILURE';

export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_DELETE_REQUEST = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_DELETE_REQUEST';
export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_DELETE_SUCCESS = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_DELETE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_DELETE_FAILURE = 'INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_DELETE_FAILURE';

export const loadIndividualConsultationScheduleItems = (options) => ({
	[CALL_API]: {
		types: [
			INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_REQUEST,
			INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_SUCCESS,
			INDIVIDUAL_CONSULTATIONS_SCHEDULE_ITEMS_FAILURE
		],
		endpoint: 'api/individualConsultationScheduleItems',
		request: options,
		schema: Schemas.INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_ARRAY
	}
});

export const fetchIndividualConsultationScheduleItem = (id) => ({
	[CALL_API]: {
		types: [
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_FETCH_REQUEST,
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_FETCH_SUCCESS,
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_FETCH_FAILURE
		],
		endpoint: `api/individualConsultationScheduleItems/${id}`,
		schema: Schemas.INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM
	}
});

export const createIndividualConsultationScheduleItem = (options, history) => ({
	[CALL_API]: {
		types: [
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_CREATE_REQUEST,
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_CREATE_SUCCESS,
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_CREATE_FAILURE
		],
		endpoint: 'api/individualConsultationScheduleItems',
		method: 'POST',
		request: options,
		schema: Schemas.INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM,
		form: 'individualConsultationsScheduleFilter',
		transition: {
			history,
			successPath: () => '/individualConsultationsSchedule'
		}
	}
});

export const updateIndividualConsultationScheduleItem = (id, options, history) => ({
	[CALL_API]: {
		types: [
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEMS_UPDATE_REQUEST,
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEMS_UPDATE_SUCCESS,
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEMS_UPDATE_FAILURE
		],
		endpoint: `api/individualConsultationScheduleItems/${id}`,
		method: 'PUT',
		request: options,
		schema: Schemas.INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM,
		form: 'individualConsultationsScheduleFilter',
		transition: {
			history,
			successPath: () => '/individualConsultationsSchedule'
		}
	}
});

export const deleteIndividualConsultationScheduleItem = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_DELETE_REQUEST,
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_DELETE_SUCCESS,
			INDIVIDUAL_CONSULTATION_SCHEDULE_ITEM_DELETE_FAILURE
		],
		endpoint: `api/individualConsultationScheduleItems/${id}`,
		method: 'DELETE',
		onSuccessEvent
	}
});